import React from 'react';
import { PauseCircle, XCircle } from 'lucide-react';

const WorkStopped = ({ tasks }) => {
    const count = tasks?.length || 0;

    return (
        <div className="bg-white rounded-2xl p-6 shadow-md">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-gray-900">Delay During Task</h3>
                <span className="text-[#E65100] text-lg font-bold">{String(count).padStart(2, '0')}</span>
            </div>

            <div>
                <div className="bg-[#FFCC80] rounded-lg px-4 py-3 flex items-center mb-2">
                    <PauseCircle size={28} className="text-white fill-[#E65100] mr-3" />
                    <div>
                        <div className="text-[#5D4037] font-semibold text-base">Delay During Task ({count})</div>
                        <div className="text-[#8D6E63] text-xs">Started but now blocked</div>
                    </div>
                </div>
                {tasks?.length > 0 ? (
                    <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto pr-1 custom-scrollbar">
                        {tasks.map((task) => (
                            <div
                                key={task.id}
                                className="bg-white border border-[#FFCC80] rounded-lg px-4 py-3 flex items-start shadow-sm"
                            >
                                <XCircle size={20} className="text-[#E65100] mr-3 mt-0.5 flex-shrink-0" />
                                <div className="flex flex-col gap-1">
                                    <span className="text-sm text-gray-700 font-medium">{task.name}</span>
                                    {task.workType?.name && (
                                        <span className="text-xs text-orange-700 bg-orange-100 px-2 py-0.5 rounded w-fit">
                                            {task.workType.name}
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center py-10 px-4">
                        {/* Icon */}
                        <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-green-500"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                        </div>

                        {/* Main Message */}
                        <h4 className="text-gray-900 font-semibold text-base mb-2">
                            No Work Stopped
                        </h4>

                        {/* Descriptive Text */}
                        <p className="text-gray-500 text-sm text-center max-w-xs">
                            Great! No tasks have been stopped or blocked during execution today.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WorkStopped;
